// src/client/components/PaymentMethodPicker.tsx
import {
  SUPPORTED_MM_PROVIDERS,
  PROVIDER_DISPLAY_NAME,
  type MobileMoneyProvider,
} from '@/constants/config';
import styles from './PaymentMethodPicker.module.css';

interface Props {
  value: MobileMoneyProvider;
  onChange: (next: MobileMoneyProvider) => void;
}

export default function PaymentMethodPicker({ value, onChange }: Props) {
  return (
    <div className={styles.wrap} role="group" aria-label="Mobile money provider">
      {SUPPORTED_MM_PROVIDERS.map((p) => {
        const active = p === value;
        return (
          <button
            key={p}
            type="button"
            aria-pressed={active}
            className={[styles.opt, active && styles.active].filter(Boolean).join(' ')}
            onClick={() => onChange(p)}
          >
            <span>{PROVIDER_DISPLAY_NAME[p]}</span>
          </button>
        );
      })}
    </div>
  );
}
